import React from 'react';
import styles from './layout.module.scss';
import dotsPattern from '@/evercall/ui/assets/pattern.svg';
import FooterPattern from '@framework/ui/Pages/Landing/Sections/FooterPattern';

interface IProps {
  children: React.ReactNode,
  headerTitle: React.ReactNode,
  headerSubTitle?: React.ReactNode,
  isFooterPatternVisible?: boolean,
}

const StaticPageLayout = (
  {
    headerTitle,
    headerSubTitle,
    children,
    isFooterPatternVisible = true,
  }: IProps,
) => (
  <main className={ styles.staticPageContainer }>
    <section className={ styles.staticPageHeaderWrapper }>
      <h1 className={ styles.staticPageHeaderTitle }>{ headerTitle }</h1>
      { headerSubTitle && (
        <p className={ styles.staticPageHeaderSubTitle }>
          There is no contractual commitment to use Evercall when submitting this form.<br />
          We’ll first confirm our availability with you, you then confirm if you wish to proceed.
        </p>
      ) }
      <div className={ styles.dotsPattern }>
        <img src={ dotsPattern.src } />
      </div>
    </section>
    { children }
    { isFooterPatternVisible && (<FooterPattern className={ styles.footerPattern } />) }
  </main>
);

export default StaticPageLayout;
